import { PaymentClient, Transaction } from "../../types/transaction";
import { generateAPI } from "../api.generator";


export const buyInAppPackage = generateAPI<
  {
    body: {
      iapID: string;
      paymentClient: PaymentClient;
    }
  },
  Transaction
>("post", "mail-credits/in-app-package/buy");
